import { Fragment, useEffect, useState } from "react";
import ViewHeader from "../SubComponents/ViewHeader";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";
import ResCard from "../SubComponents/ResCard";
import { useParams } from "react-router-dom";
import MHButton from "../../Common/Button/MHButton";
import dayjs from "dayjs";
import Slider from "react-slick";

import MHSubscribe from "../../Layout/MHSubscribe";
import MHFooter from "../../Layout/MHFooter";
import { convertUTCToTime } from "../../../utils/utils";
import { ResourcesData } from "../../NewLanding/EventGlance";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { db } from "../../../firebase";
import AnimatedLoaderText from "../../Common/Loading/AnimatedLoaderText";

const ViewEvent = () => {
  const [summitData, setSummitData] = useState<ResourcesData | null>(null); // ← fix
  const [summitPastData, setSummitPastData] = useState<ResourcesData[]>([]); // ← fix

  const slice = summitPastData.slice(0, 3);

  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    const getPodcast = async () => {
      try {
        const collectionRef = collection(db, "caf-summit-list");
        const querySnapshot = await getDocs(
          query(collectionRef, where("slug", "==", slug)),
        );

        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          setSummitData(doc.data() as ResourcesData);
        }
      } catch (error) {
        console.error("Error fetching podcast:", error);
      }
    };

    if (slug) getPodcast();
  }, [slug]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const collectionRef = collection(db, "caf-past-summit");
        const querySnapshot = await getDocs(
          query(collectionRef, orderBy("slug", "asc")),
        );

        const data = querySnapshot.docs.map((doc) => ({
          ...(doc.data() as ResourcesData), // ← fix
        }));

        setSummitPastData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const settings = {
    centerMode: true,
    centerPadding: "22px",
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 800,
    autoplay: false,
  };

  if (!summitData)
    return <AnimatedLoaderText text="Fetching data, please wait..." />;

  return (
    <Fragment>
      <ViewHeader
        titles={summitData.title}
        headerClassName="bg-lilac-300 w-full h-full px-4 md:px-0 md:pt-2 lg:pt-6 pt-6 md:pl-12 lg:pl-20 relative"
        description={summitData.caption}
        headerDateClass="text-center hidden md:hidden mt-12 text-[12px] uppercase font-areaExt"
        imageUrl={summitData.imgSrc}
        // imageUrl="https://res.cloudinary.com/mother-honestly/image/upload/v1661961579/image_1_ynjaab.png"
        imageClass="overflow-hidden h-full w-full right-0 absolute"
        categoryClassName="lg:bottom-2 md:-bottom-0 md:absolute md:w-2/3"
        category={[]}
        // categoryOne={
        //   checkInvalidArray(data.newItemList).length
        //     ? data.newItemList[0].interestName
        //     : ""
        // }
        downloadClassName="hidden flex -ml-4 my-6"
        podClassName="mt-10 flex gap-32 hidden"
        ticketClassName="pt-12 md:pt-2 lg:pt-20 text-center md:text-start"
        // SocialClassName="block"
        TabSocialClass="absolute gap-4 bottom-9 text-center place-content-center hidden md:flex lg:hidden md:right-4"
        ticketLink={summitData.registrationLink}
        date={dayjs(summitData.eventDate).format("MMMM D ")}
        bottomDateClass="hidden"
        startTime={convertUTCToTime(summitData.eventDate)}
        endTime={convertUTCToTime(summitData.eventDate)}
        dateTwo={dayjs(summitData.eventDate).format("MMMM D, YYYY")}
        dateClassName="text-center md:text-left pb-8 md:pb-0 md:w-3/4 text-xl md:text-[22px] font-areaSemi"
        episodeClassName="hidden"
        authorClassName="hidden"
        event
      />

      <Box className="px-8 md:px-20 lg:px-[300px] py-10 bg-white">
        {/* <Typography
          variant="h3"
          color="primary"
          className="text-[22px] text-start font-areaSemi font-[600]"
        >
          {summitData.caption}
        </Typography> */}

        {/* Event Description */}
        <div dangerouslySetInnerHTML={{ __html: summitData.description }} />

        {/* <img
          src={summitData ? summitData.imageList[0] : ""}
          alt="Resource Image"
          className="mx-auto bg-pink-700 w-full h-[257px] bodyImage object-cover lg:w-full lg:h-[630px] md:h-[456px]"
        /> */}

        <Box className="flex  justify-center py-12">
          <MHButton
            onClick={() => {
              window.open(summitData.registrationLink);
            }}
            sx={{ width: "155px" }}
          >
            Reserve A Seat
          </MHButton>
        </Box>
      </Box>

      <Box className="bg-gray-300 h-[1px] w-[91.4%] opacity-50 overflow-hidden mx-auto"></Box>

      {/* For Mobile */}
      <Box className="mx-auto pt-10 md:hidden block bg-white px-4 py-4 overflow-x-hidden">
        <Typography
          variant="h1"
          color="primary"
          className="font-areaSemi text-xl text-center py-12"
        >
          Past Events You Might like
        </Typography>
        <Slider {...settings}>
          {slice.map((res, index) => (
            <Grid item xs={12} md={6} lg={3} key={index}>
              <ResCard
                cardClass="relative w-[305px] mb-10 h-[452px] object-cover bg-cream-100 rounded-md shadow-sm"
                iconClass="absolute top-14 left-[38%] mt-12 w-20 h-20" //absolute top-10 ml-20 mt-12 w-20 h-20
                imgBg="bg-pink-700 h-[305px]"
                bodyBg="bg-cream-100"
                top={dayjs(res.eventDate).format("MMMM D")} // Use res.startTime directly
                imageSrc={res.imgSrc}
                podTop="hidden"
                title={res.title}
                venue={res.venue}
                eventType={res.eventType}
                titleUrl={`/events/past/${res.slug}`}
                playUrl={`/events/past/${res.slug}`}
              />
            </Grid>
          ))}
        </Slider>
      </Box>

      {/* For Web */}
      <Box className="mx-auto pt-10 hidden md:block bg-white px-12 md:px-20 py-4">
        <Typography
          variant="h1"
          color="primary"
          className="font-areaSemi text-xl text-center py-12"
        >
          Past Events You Might like
        </Typography>
        <Grid container spacing={2}>
          {slice.map((res, index) => (
            <Grid item xs={12} sm={6} md={3} lg={3} key={index}>
              <ResCard
                cardClass="relative w-[305px] mb-10 h-[452px] object-cover bg-cream-100 rounded-md shadow-sm"
                iconClass="absolute top-14 left-[38%] mt-12 w-20 h-20" //absolute top-10 ml-20 mt-12 w-20 h-20
                imgBg="bg-pink-700 h-[305px]"
                bodyBg="bg-cream-100"
                top={dayjs(res.eventDate).format("MMMM D")} // Use res.startTime directly
                imageSrc={res.imgSrc}
                podTop="hidden"
                title={res.title}
                venue={res.venue}
                eventType={res.eventType}
                titleUrl={`/events/past/${res.slug}`}
                playUrl={`/events/past/${res.slug}`}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
      <MHSubscribe />
      <MHFooter />
    </Fragment>
  );
};

export default ViewEvent;
